import { Pipe, PipeTransform } from '@angular/core';
import { SalesByPosOperatorsResponse } from '../../models';

@Pipe({
  name: 'operatorSort'
})
export class OperatorSortPipe implements PipeTransform {
  transform(
    salesByPosOperators: SalesByPosOperatorsResponse | undefined,
    sortColumn: 'name' | 'orders',
    sortDirection: 'asc' | 'desc'
  ): { key: string; value: any }[] {
    if (!salesByPosOperators) {
      return [];
    }

    const operatorEntries = Object.entries(salesByPosOperators);

    return operatorEntries
      .sort((a, b) => {
        let comparison = 0;

        if (sortColumn === 'name') {
          const nameA = a[0].toLowerCase();
          const nameB = b[0].toLowerCase();
          comparison = nameA.localeCompare(nameB);
        } else if (sortColumn === 'orders') {
          const ordersA = a[1].total_tickets || 0;
          const ordersB = b[1].total_tickets || 0;
          comparison = ordersA - ordersB;
        }

        return sortDirection === 'asc' ? comparison : -comparison;
      })
      .map(([key, value]) => ({ key, value }));
  }
}
